import { Fragment, Component } from 'react';
import { ReactSVG } from 'react-svg';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ErrorComponent, hasErrors } from '../../../index';

class ThemeComponent extends Component {
  render() {
    const {
      className, id, label, errors, children, prefixIcon, postfixIcon,
    } = this.props;

    const classNames = classnames({
      prefixed: prefixIcon !== null,
      postfixed: postfixIcon !== null,
      'has-errors': hasErrors(errors),
    }, className);

    return (
      <Fragment>
        <div className={classNames}>
          {children}
          { label ? <label htmlFor={id}>{label}</label> : null }
          {prefixIcon !== null ?
            <div className="prefix">
              <ReactSVG 
                src={prefixIcon} 
              />
            </div>
            : null
          }
          {postfixIcon !== null ?
            <div className="postfix">
              <ReactSVG src={postfixIcon} />
            </div>
            : null
          }
        </div>
        <ErrorComponent errors={errors} />
      </Fragment>
    );
  }
}

ThemeComponent.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  className: PropTypes.string,
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  prefixIcon: PropTypes.string,
  postfixIcon: PropTypes.string,
};

ThemeComponent.defaultProps = {
  className: null,
  id: null,
  label: '',
  errors: null,
  prefixIcon: null,
  postfixIcon: null,
};

export default ThemeComponent;
